import React from 'react';
import { Form as FormWrapper } from 'antd';

function Form({ children, onSubmit, onCancel }) {
  const [form] = FormWrapper.useForm();

  /*
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };
  */

  return (
    <FormWrapper 
      name="fanthon_form" 
      layout="vertical" 
      autoComplete="off"
      noValidate
      form={form}
      onFinish={onSubmit}
      onFinishFailed={onCancel}
      // {...formItemLayout} 
    >
      {children}
    </FormWrapper>
  )
};

export default Form;